// maybe to refactor some day into one popup component, though I'm not sure it makes sense
angular.module(NgAppName).component('crContactV2PreDevPopup', {
    templateUrl: 'crContactV2PreDevPopup.html',
    transclude:true,
  bindings: {},
  controller: ['$rootScope', '$timeout', '$interval', '$window', "$cookies", 'PubSub', '$element', '$document', 'crResourcesService',
    function($rootScope, $timeout, $interval, $window, $cookies, PubSub, $element, $document, crResourcesService) {
      let ctrl = this;
      let popupChild;
      this.target = null;
      this.user = null;
      this.rpc = null;
      this.buildingName = null;

      // move this component to the body and set up event listeners
      this.$onInit = function() {
        let bodyChildren = Array.from(document.body.children);
        let existingInBody = bodyChildren.find(function(child) {
          return child.tagName.toLowerCase() === 'cr-contact-v2-pre-dev-popup';
        });

        if (!existingInBody) {
          // Move the component to the body
          angular.element(document.body).append($element);
          popupChild = $element[0].querySelector('.cr-contact-v2-pre-dev-popup');

          // hide on overlay click
          angular.element(popupChild).on('click', function(event) {
            var popupBlock = $element[0].querySelector('.popup-block');
            var closeButton = $element[0].querySelector('.close');
            
            if (popupBlock && !popupBlock.contains(event.target)) {
              angular.element(popupChild).removeClass('visible');
              $rootScope.$broadcast('resetContactV2Form');
            }

            if (closeButton && closeButton.contains(event.target)) {
              angular.element(popupChild).removeClass('visible');
              $rootScope.$broadcast('resetContactV2Form');
            }
          });
        } else {
          // removing others, as we need only one
          $element.remove();
        }

        // open and fill
        $rootScope.$on('openContactV2PreDevPopup', function(event, data) {
          if (popupChild) {
            $timeout(function() {
              ctrl.target = data.target;
              ctrl.user = data.user;
              ctrl.user.subscribe = true;
              ctrl.buildingName = data.buildingName;
              ctrl.rpc = data.rpc;
              angular.element(popupChild).addClass('visible');
            });
          }
        });
      };


    }
  ]
});


document.addEventListener('DOMContentLoaded', function() {
  document.addEventListener('click', function(event) {
    let target = event.target.closest('.contact-v2-open-predev'); // Find the closest element with this class
    if (target) {
      // Only proceed if the click was on a .contact-v2-open button
      let rpc = target.getAttribute('data-rpc');
      let userData = JSON.parse(target.getAttribute('data-user'));
      let targetData = JSON.parse(target.getAttribute('data-target'));
      let buildingName = target.getAttribute('data-building-name');

      // Trigger AngularJS event
      let injector = angular.element(document.body).injector();
      let rootScope = injector.get('$rootScope');

      rootScope.$apply(function() {
        rootScope.$broadcast('openContactV2PreDevPopup', {
          user: userData,
          target: targetData,
          buildingName: buildingName,
          rpc: rpc,
        });
      });
    }
  });
});
